import { createCookie } from '#/utils/cookies';

import { localeLinkAttr } from './locale-link.attributes';
import type { Snippet } from './types/Snippet';

export const localeLinkSnippet = {
  click(el) {
    const linkLocale = el.getAttribute(localeLinkAttr);
    if (linkLocale) createCookie('_LOCALE_', linkLocale, 1825);
  },
} satisfies Snippet;
